import { useEffect } from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import Link from '@mui/material/Link'
import { useTranslation } from 'react-i18next'
// import ImageWithSkeleton from '../../components/ImageWithSkeleton'
// import { fadeInAnimation } from '../../utils/cssFunctions'
import HelmetMeta from '../../layouts/HelmetMeta'
import OtherPagesHeader from './OtherPagesHeader'

export default function Volunteers () {
  const { t } = useTranslation('others')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container sx={{ mb: 4 }} maxWidth='xl' disableGutters>
      <HelmetMeta
        {...{
        title: t('volunteers.metaTitle'),
        description: t('volunteers.tagline'),
        image: '/img/peaks-volunteers.jpg'
      }}
      />
      <Box sx={{ position: 'relative' }}>
        <OtherPagesHeader
          {...{
          image: 'https://d1hi0tbu2kom2c.cloudfront.net/img/peaks-volunteers.jpg',
          ratio: 1.765,
          title: t('volunteers.headerTitle'),
          subtitle: t('volunteers.tagline')
        }}
        />
      </Box>
      <Box
        sx={{
        mx: 2
      }}
      >
        <Box
          sx={{
            my: 4,
            textAlign: 'center'
          }}
        >
          <Button
            component={Link}
            target='_blank'
            href='https://chat.whatsapp.com/KeyDv14ynfg8SIcHyyDfde'
            startIcon={<WhatsAppIcon />}
            variant='outlined'
            sx={{ color: 'white', mt: 2, '&:hover': { color: '#ddd' } }}
          >
            {t('volunteers.whatsappMarshals')}
          </Button>
        </Box>

        <Typography>
          {t('volunteers.intro')} {t('volunteers.ready')}
        </Typography><br />
        <Typography>
          {t('volunteers.outro')}
        </Typography><br />
      </Box>
    </Container>
  )
}
